// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '328f0b1861684fcbdfcd78d175494d0faf21e932';
export const BUILD_NUMBER = '233';
export const BUILD_TIMESTAMP = '2026-09-11T02:49:23.626Z';
